import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RoleEntity, ResourceEntity, ComponentEntity } from '@/services/apis';

const initialState = {
  roles: [],
  resources: [],
  components: [],
  loading: true,
  error: false,
  errorMessage: '',
  totalRecords: 0,
  rolesCount: 0,
  resourcesCount: 0,
  componentsCount: 0,
};

// ROLES
export const createNewRole = createAsyncThunk('entities/createNewRole', async (roleData: any) => {
  const data = await RoleEntity.createRole(roleData);
  return data;
});

export const uploadNewRole = createAsyncThunk('entities/uploadNewRole', async (roleData: FormData) => {
  const data = await RoleEntity.uploadRoles(roleData);
  return data;
});

export const fetchRoles = createAsyncThunk('entities/fetchRoles', async ({ page, rowsPerPage, appid }: any) => {
  const response = await RoleEntity.fetchRoles({
    page, rowsPerPage,
    app_id: appid
  });
  return response;
});

export const deleteRole = createAsyncThunk('entities/deleteRole', async (roleId: string) => {
  const response = await RoleEntity.deleteRole({ roleId });
  return response;
});

export const updateRole = createAsyncThunk('entities/updateRole', async (roleData: any) => {
  const data = await RoleEntity.updateRoleDetails(roleData);
  return data;
});

// RESOURCES
export const createNewResource = createAsyncThunk('entities/createNewResource', async (resoucesData: any) => {
  const data = await ResourceEntity.createResource(resoucesData);
  return data;
});

export const fetchResources = createAsyncThunk(
  'entities/fetchResources',
  async ({ page, rowsPerPage, app_id }: any) => {
    const response = await ResourceEntity.fetchResources({ page, rowsPerPage, app_id });
    return response;
  },
);

export const deleteResource = createAsyncThunk('entities/deleteResource', async (resourceId: string) => {
  const response = await ResourceEntity.deleteResource({ resourceId });
  return response;
});

export const uploadNewResources = createAsyncThunk('entities/uploadNewResources', async (roleData: FormData) => {
  const data = await ResourceEntity.uploadResources(roleData);
  return data;
});

export const updateResource = createAsyncThunk('entities/updateResource', async (resourceData: any) => {
  const data = await ResourceEntity.updateResourceDetails(resourceData);
  return data;
});


// COMPONENTS
export const createNewComponent = createAsyncThunk('entities/createNewComponent', async (componentData: any) => {
  const data = await ComponentEntity.createComponent(componentData);
  return data;
});

export const fetchComponents = createAsyncThunk(
  'entities/fetchComponents',
  async ({ app_id, page, rowsPerPage }: any) => {
    const response = await ComponentEntity.fetchComponents({ app_id, page, rowsPerPage });
    return response;
  },
);

export const deleteComponent = createAsyncThunk('entities/deleteComponent', async (componentId: string) => {
  const response = await ComponentEntity.deleteComponent({ componentId });
  return response;
});

export const uploadNewComponent = createAsyncThunk('entities/uploadNewComponent', async (roleData: FormData) => {
  const data = await ComponentEntity.uploadComponents(roleData);
  return data;
});

export const updateComponent = createAsyncThunk('entities/updateComponent', async (componentData: any) => {
  const data = await ComponentEntity.updateComponentDetails(componentData);
  return data;
});


export const EntitiesSlice = createSlice({
  name: 'entities',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRoles.pending, (state, action) => {
      return { ...state, roles: [], rolesCount: 0, loading: true };
    });
    builder.addCase(fetchRoles.fulfilled, (state, action) => {
      state.roles = action.payload.data;
      state.rolesCount = action.payload.data.length;
      state.loading = false;
    });
    builder.addCase(fetchRoles.rejected, (state) => {
      return { ...state, roles: [], rolesCount: 0, loading: false };
    });
    builder.addCase(fetchResources.pending, (state, action) => {
      return { ...state, resources: [], resourcesCount: 0, loading: true };
    });
    builder.addCase(fetchResources.fulfilled, (state, action) => {
      state.resources = action.payload?.data;
      state.resourcesCount = action.payload?.data?.length;
      state.loading = false;
    });
    builder.addCase(fetchResources.rejected, (state) => {
      return { ...state, resources: [], resourcesCount: 0, loading: false };
    });
    builder.addCase(fetchComponents.pending, (state, action) => {
      return { ...state, components: [], componentsCount: 0, loading: true };
    });
    builder.addCase(fetchComponents.fulfilled, (state, action) => {
      state.components = action.payload?.data;
      state.componentsCount = action.payload?.data?.length;
      state.loading = false;
    });
    builder.addCase(fetchComponents.rejected, (state) => {
      return { ...state, components: [], componentsCount: 0, loading: false };
    });
  },
});

export const entitiesSelector = (state: any) => state.entities;

export default EntitiesSlice.reducer;
